<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="m18.92 5.01c-.2-.59-.76-1.01-1.42-1.01h-11c-.66 0-1.21.42-1.42 1.01l-2.08 5.99v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8zm-12.07.99h10.29l1.08 3.11h-12.45zm12.15 10h-14v-5h14z"
    />
    <path
      d="m7.5 15c.82843 0 1.5-.6716 1.5-1.5s-.67157-1.5-1.5-1.5-1.5.6716-1.5 1.5.67157 1.5 1.5 1.5z"
    />
    <path
      d="m16.5 15c.8284 0 1.5-.6716 1.5-1.5s-.6716-1.5-1.5-1.5-1.5.6716-1.5 1.5.6716 1.5 1.5 1.5z"
    />
  </svg>
</template>
